import responsiveBreakpointsStyle from "core-web/utils/responsiveBreakpointsStyle";
import styled from "theme/libs/styled";
import variables from "theme/config/variables";

/**
 * Add a fixed padding to left and right.
 * Useful when content high up in the DOM-tree should have the same padding on each side. Like content, header and footer.
 * If some content inside the ContentWrapper should cover the whole viewport, BleedWrapper can be used.
 */

//                             xs                            sm    md    lg
export const contentPadding = [variables.sitePaddingXMobile, null, null, variables.sitePaddingXDesktop];

const ContentWrapper = styled("div")`
    width: 100%;
    /* margin-left: auto;
    margin-right: auto; */
    ${responsiveBreakpointsStyle(contentPadding, "padding-left: {value}px; padding-right: {value}px;")}
`;

export default ContentWrapper;
